export const p_home = '/UID-Royal-Family';
export const p_family_members = p_home + '/family_members';